/* ====================================================== */
/* ====================================================== */
/* ======= KLEVU TEMPLATE JS CUSTOMIZATION CODE ========= */
/* ============== QUICK SEARCH JAVASCRIPT =============== */
/* ======================== Moss ======================== */
/* ====================================================== */
/* ====================================================== */

var klevu_layoutType = "basic";
var klevu_layoutView = "grid";

const klevu_quickSearchSuggestionsLimit = 5;
const klevu_quickSearchRecommendedCategoriesLimit = 5;
const klevu_quickSearchRecommendedPagesLimit = 3;

klevu({
    theme: {
        quickSearch: {
            loadDefaultStyles: false
        },
        landing: {
            loadDefaultStyles: false
        },
        catnav: {
            loadDefaultStyles: false
        },
        setHelpers: {
            all: {
                setKlevuQuickPopupTopPositionVariable: function () {
                    klevu.each(
                        klevu.dom.find(".klevuWrap"),
                        function (key, currentElement) {
                            const topPosition = currentElement.getBoundingClientRect().top;
                            document.documentElement.style.setProperty(
                                "--klevuQuickPopupTopPosition",
                                `${topPosition}px`
                            );
                        }
                    );
                }
            },
        },
      // Settings for infinite scroll - currently commented out because of the unwanted scollToTop animation
      //   modules: {
      //    resultInfiniteScroll: {
      //      quickSearch: {
      //        enable: true
      //      },
      //      searchResultsPage: {
      //        enable: true
      //      },
      //      categoryPage: {
      //        enable: true
      //      }
      //    }
      //  }
    },
});

klevu.beforeActivation("quick", function (data, scope) {
    klevu.each(klevu.search.extraSearchBox, function (key, box) {
        box.getScope().template.setTemplate(klevuQuickTemplateBaseCustom, "klevuTemplateBase", true);
        box.getScope().template.setTemplate(klevuQuickProductsCustom, "klevuQuickProducts", true);
        box.getScope().template.setTemplate(klevuQuickAutoSuggestionsCustom, "klevuQuickAutoSuggestions", true);
        box.getScope().template.setTemplate(klevuQuickCategorySuggestionsCustom, "klevuQuickCategorySuggestions", true);
        box.getScope().template.setTemplate(klevuQuickPageSuggestionsCustom, "klevuQuickPageSuggestions", true);
        box.getScope().template.setTemplate(klevuQuickTemplateTabResultsCustom, "klevuQuickTemplateTabResults", true);
        box.getScope().template.setTemplate(klevuQuickTemplateFiltersCustom, 'klevuQuickTemplateFilters', true);
        box.getScope().template.setTemplate(klevuSearchPersonalizationsCustom, 'klevuSearchPersonalizations', true);
        box.getScope().template.setTemplate(klevuQuickNoResultsPopularProductsCustom, 'quickNoResultsPopularProducts', true);

        box.getScope().template.setTemplate(quickProductTemplate, 'klevuQuickProductBlock', true);
    });
});

klevu.modifyRequest("quick", function (data, scope) {
  // Klevu doesn't trigger a search request for queries shorter than 3 characters
  // In that case, we manually add search request based on that query
  if(data.request.current.recordQueries.length < 1) {
    data.request.current.recordQueries.push({
      id: "productList",
      typeOfRequest: "SEARCH",
      settings: {
        query: {
          term: data.context.term
        },
        limit: 8,
        typeOfRecords: [
          "KLEVU_PRODUCT"
        ],
        fields: [
          "id",
          "name",
          "url",
          "typeOfRecord"
        ],
        sort: "RELEVANCE",
        fallbackQueryId: "productListFallback"
      }
    });
  }

  klevu.each(data.request.current.recordQueries, function (key, query) {
      const queryTerm = query.settings.query.term

      // disabling filters
      if(query.filters) {
        query.filters.filtersToReturn.enabled = false;
      }
      // No results limit
      const queryID = klevu.getObjectPath(query, "id");
      if (queryID === 'noResultsFoundPopularProductList') {
          klevu.setObjectPath(query, "settings.limit", 8);
      }
      // No results limit END

      if (queryID === 'productList') {
        // Add autocomplete suggestions to request
        if (!data.request.current.suggestions) {
          data.request.current.suggestions = [];
        }
        data.request.current.suggestions.push({
          id: "autosuggestion",
          typeOfRequest: "AUTO_SUGGESTIONS",
          query: queryTerm,
          limit: klevu_quickSearchSuggestionsLimit
        });
        // Add category/collections suggestions to request
        data.request.current.recordQueries.push({
          id: "categoryCompressed",
          typeOfRequest: "SEARCH",
          settings: {
            query: {
              term: queryTerm
            },
            limit: klevu_quickSearchRecommendedCategoriesLimit,
            typeOfRecords: [
              "KLEVU_CATEGORY"
            ],
            fields: [
              "id",
              "name",
              "url",
              "typeOfRecord"
            ],
            sort: "RELEVANCE"
          }
        });

        // Add page suggestions to request
        // data.request.current.recordQueries.push({
        //   id: "cmsCompressed",
        //   typeOfRequest: "SEARCH",
        //   settings: {
        //     query: {
        //       term: queryTerm
        //     },
        //     limit: klevu_quickSearchRecommendedPagesLimit,
        //     typeOfRecords: [
        //       "KLEVU_CMS"
        //     ],
        //     fields: [
        //       "id",
        //       "name",
        //       "url",
        //       "typeOfRecord"
        //     ],
        //     sort: "RELEVANCE"
        //   }
        // });
      }
  });
});

klevu.afterTemplateRender("landing,catnav", function(data, scope){
    document.body.style.minHeight = '0';
    const currentDocumentHeight = document.documentElement.scrollHeight;
    document.body.style.minHeight = `${currentDocumentHeight}px`;

    scope.kScope.chains.events.keyUp.remove({name: "scrollToTop"});
});

/**
 * Shared helper: fetch product JSON and render cards via JS grid renderer.
 * Used by both quick search and landing page afterTemplateRender hooks.
 */
async function renderKlevuProductCards(productIds, containerSelector) {
    if (!Array.isArray(productIds) || productIds.length === 0) return;
    var container = document.querySelector(containerSelector);
    if (!container) {
        console.log("No matching container:", containerSelector);
        return;
    }

    if (!window.theme?.productGrid?.generateSimpleProductGridHtml) {
        console.warn('Product grid renderer not available');
        return;
    }

    await Promise.all(productIds.map(async function (prod) {
        try {
            var res = await fetch(prod.url + '?view=klevu-json');
            var holder = container.querySelector('[data-id="' + prod.id + '"] div.kuProdWrapHolder');
            if (!holder) {
                console.log("Could not find product holder", prod.id);
                return;
            }

            if (!res.ok) {
                holder.closest('.klevuProduct')?.remove();
                return;
            }

            var productData = await res.json();
            var cardHtml = window.theme.productGrid.generateSimpleProductGridHtml(productData, {
                includeWrapper: true,
                imgSize: '460x460',
                showTopLine: true,
            });
            holder.innerHTML = cardHtml;
        } catch (err) {
            console.log('Klevu card render error:', err, prod);
        }
    }));
}

klevu.afterTemplateRender("quick", async function (data, scope) {
    scope.kScope.template.getHelpers().setKlevuQuickPopupTopPositionVariable();

    window.addEventListener("resize", function () {
      scope.kScope.template.getHelpers().setKlevuQuickPopupTopPositionVariable();
    });

    try {
        var productIds = data.template.query.productList?.result
            || data.template.query.noResultsFoundPopularProductList?.result
            || data.template.query.productListFallback?.result
            || [];
        await renderKlevuProductCards(productIds, '.kuQuickResultsListContainer');
    } catch (err) {
        console.log('Klevu quick search render error:', err);
    }
});

window._klvReady= window._klvReady|| [];
window._klvReady.push(function(){
  var itemsPerPage = 36;
  localStorage.setItem('klv_limits_productList', itemsPerPage);
  localStorage.setItem('klv_limits_contentList', itemsPerPage);
});

(function (klevu) {
    klevu.extend({
        productCarousel: {
            base: {
                initProductsSlider: function (kuCarousel) {
                    return; // we don't need carousel
                }
            }
        }
    });
})(klevu);
/* ============== QUICK SEARCH TEMPLATES =============== */
const klevuQuickTemplateBaseCustom = `
  <div class="klevu-fluid kuPreventDocumentClick">
      <%= helper.render('customBlockTopOuter',scope) %>
      <div id="klevuSearchingArea" class="klevuQuickSearchingArea">
          <div ku-container data-container-id="ku_quick_main_container" data-container-role="main">
              <%= helper.render('customBlockTop',scope) %>
              <header ku-container data-container-id="ku_quick_main_header_container" data-container-role="header">
                  <section ku-block data-block-id="ku_quick_main_header_sub_panel"></section>
                  <section ku-block data-block-id="ku_quick_main_header_banner">
                      <%=helper.render('klevuQuickPromotionBanner',scope,data,"top") %>
                  </section>
                  <section ku-block data-block-id="ku_quick_main_header_site_navigation">
                    <%=helper.render('kuTemplatePopularSearches',scope) %>
                    <%=helper.render('kuTemplateRecentSearches',scope) %>

                    <%=helper.render('klevuQuickAutoSuggestions',scope) %>
                    <%=helper.render('klevuQuickCategorySuggestions',scope) %>
                    <%=helper.render('klevuQuickPageSuggestions',scope) %>
                  </section>
              </header>

              <div class="klevuResultsWrapper">
              <% if(data.query.productList) { %>
                  <%=helper.render('klevuQuickTemplateResultsHeadingTitle',scope,data,"productList") %>
                  <%= helper.render('klevuQuickTemplateTabResults',scope) %>
                  <%= helper.render('klevuQuickProducts',scope) %>
                  <%= helper.render('klevuQuickOtherContent',scope) %>
              <% } else { %>
                  <div class="kuSearchPersonalizationsContainer">
                      <%= helper.render('klevuSearchPersonalizations',scope) %>
                  </div>
              <% } %>
              </div>

              <footer ku-container data-container-id="ku_quick_main_footer_container" data-container-role="footer">
                  <section ku-block data-block-id="ku_quick_main_footer_sub_panel"></section>
                  <section ku-block data-block-id="ku_quick_main_footer_banner">
                      <%=helper.render('klevuQuickPromotionBanner',scope,data,"bottom") %>
                  </section>
              </footer>
              <%= helper.render('customBlockBottom',scope) %>
          </div>
      </div>
  </div>
`

const klevuSearchPersonalizationsCustom = `
  <div ku-container data-container-id="ku_quick_main_content_container" data-container-role="content">
      <section ku-container data-container-id="ku_quick_main_content_left" data-container-position="left" data-container-role="left">
          <div ku-block data-block-id="ku_quick_left_facets"></div>
          <div ku-block data-block-id="ku_quick_left_call_outs"></div>
          <div ku-block data-block-id="ku_quick_left_banner"></div>
      </section>
      <section ku-container data-container-id="ku_quick_main_content_center" data-container-position="center" data-container-role="center">
          <header ku-block data-block-id="ku_quick_result_header"></header>
          <div ku-block data-block-id="ku_quick_result_items"></div>

          <div ku-block data-block-id="ku_quick_other_items">
              <% var popularProductList = klevu.getObjectPath(data,"query.noResultsFoundPopularProductList.result");%>
              <% if(popularProductList) { %>
                  <% if(popularProductList.length > 0 ) { %>
                      <div class="klevuNoResultsProductsBlock">
                          <div class="klevuPopularProductsHeading"><span class="klevuQuickHeadingText">MOST LOVED</span></div>
                          <div class="klevuQuickSearchNoResultsPopular kuQuickResultsListContainer kuQuickSearchResultsContainer" data-section="noResultsFoundPopularProductList" id="noResultsFoundPopularProductList">
                              <ul>
                                  <% helper.each(popularProductList,function(key, product){ %>
                                      <%=helper.render('klevuQuickProductBlock',scope,data,product) %>
                                  <% }); %>
                              </ul>
                          </div>
                      </div>
                  <% } %>
              <% } %>
              <%=helper.render('klevuTrendingProducts',scope) %>
              <%=helper.render('klevuRecentViewedProducts',scope) %>
          </div>

          <footer ku-block data-block-id="ku_quick_result_footer"></footer>
      </section>
      <section ku-container data-container-id="ku_quick_main_content_right" data-container-position="right" data-container-role="right">
          <div ku-block data-block-id="ku_quick_right_facets"></div>
          <div ku-block data-block-id="ku_quick_right_call_outs"></div>
          <div ku-block data-block-id="ku_quick_right_banner"></div>
      </section>
  </div>
`

const klevuQuickProductsCustom = `
<% if(data.query.productList) { %>
        <% if(data.query.productList.result.length > 0 ) { %>
            <div ku-container data-container-id="ku_quick_main_content_container" data-container-role="content" data-content="productList" >
                <section ku-container data-container-id="ku_quick_main_content_left" data-container-position="left"
                    data-container-role="left">
                    <div ku-block data-block-id="ku_quick_left_facets">
                        <% var isQuickFiltersOnLeft = klevu.search.modules.kmcInputs.base.isQuickFacetedLayoutFilterOnLeft(); %>
                        <% if(isQuickFiltersOnLeft === true && data.query.productList.filters && data.query.productList.filters.length > 0) { %>
                            <div data-section="productList" class="klevuMeta">
                                <%=helper.render('klevuQuickTemplateFilters',scope,data,"productList") %>
                            </div>
                        <% } %>
                    </div>
                    <div ku-block data-block-id="ku_quick_left_call_outs"></div>
                    <div ku-block data-block-id="ku_quick_left_banner"></div>
                </section>
                <section ku-container data-container-id="ku_quick_main_content_center" data-container-position="center"
                    data-container-role="center">
                    <header ku-block data-block-id="ku_quick_result_header"></header>
                    <div ku-block data-block-id="ku_quick_result_items">
                        <div class="klevuResultsBlock">
                            <%=helper.render('klevuQuickProductBlockTitleHeader',scope,data) %>
                            <div class="klevuQuickSearchResults klevuMeta productList" data-section="productList" id="productList" data-result-view="list" >
                                <div class="kuQuickResultsListHeader">
                                    <%=helper.render('kuTemplateQuickResultsViewSwitch',scope,data,"productList") %>
                                    <%=helper.render('klevuQuickTemplateSortBy',scope,data,"productList") %>
                                </div>
                                <div class="kuClearBoth"></div>
                                <div class="kuQuickResultsListContainer">
                                    <ul>
                                        <% helper.each(data.query.productList.result,function(key,product){ %>
                                            <%=helper.render('klevuQuickProductBlock',scope,data,product) %>
                                        <% }); %>
                                        <%=helper.render('klevuQuickTemplateInfiniteScrollDown',scope,data) %>
                                    </ul>
                                    <div class="klevuProductsViewAll">
                                      <% var queryParam = klevu.getSetting(klevu, "settings.url.queryParam"); %>
                                      <a class="theme-btn theme-btn--xxlarge theme-btn--mobile-auto-width theme-btn--ghost theme-btn--ghost-special-hover" href="<%=helper.buildUrl(data.settings.landingUrl, queryParam ,helper.stripHtml(data.settings.term))%>" target="_parent"><%=helper.translate("View Results")%> (<%= data.query.productList.meta.totalResultsFound%>)</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div ku-block data-block-id="ku_quick_other_items">
                        <div data-section="productList" class="klevuMeta">
                            <%=helper.render('klevuQuickTemplatePagination',scope,data,"productList") %>
                        </div>
                    </div>
                    <footer ku-block data-block-id="ku_quick_result_footer"></footer>
                </section>
                <section ku-container data-container-id="ku_quick_main_content_right" data-container-position="right"
                    data-container-role="right">
                    <div ku-block data-block-id="ku_quick_right_facets">
                        <% var isQuickFiltersOnLeft = klevu.search.modules.kmcInputs.base.isQuickFacetedLayoutFilterOnLeft(); %>
                        <% if(isQuickFiltersOnLeft === false && data.query.productList.filters && data.query.productList.filters.length > 0) { %>
                            <div data-section="productList" class="klevuMeta">
                                <%=helper.render('klevuQuickTemplateFilters',scope,data,"productList") %>
                            </div>
                        <% } %>
                    </div>
                    <div ku-block data-block-id="ku_quick_right_call_outs"></div>
                    <div ku-block data-block-id="ku_quick_right_banner"></div>
                </section>
            </div>
        <% } else { %>
            <% var isCmsEnabled = klevu.search.modules.kmcInputs.base.getCmsEnabledValue(); %>
            <% if(isCmsEnabled) { %>
                <% if(data.query.cmsCompressed && data.query.cmsCompressed.result.length <= 0 ){ %>
                    <div ku-container data-container-id="ku_quick_main_content_container" data-container-role="content">
                        <section ku-container data-container-id="ku_quick_main_content_left" data-container-position="left"
                            data-container-role="left">
                        </section>
                        <section ku-container data-container-id="ku_quick_main_content_center" data-container-position="center"
                            data-container-role="center">
                            <div ku-block data-block-id="ku_quick_no_result_items">
                                <%=helper.render('noResultsFoundQuick',scope) %>
                            </div>
                        </section>
                        <section ku-container data-container-id="ku_quick_main_content_right" data-container-position="right"
                            data-container-role="right">
                        </section>
                    </div>
                <% } %>
            <% } else { %>
                <div ku-container data-container-id="ku_quick_main_content_container" data-container-role="content">
                    <section ku-container data-container-id="ku_quick_main_content_left" data-container-position="left"
                        data-container-role="left">
                    </section>
                    <section ku-container data-container-id="ku_quick_main_content_center" data-container-position="center"
                        data-container-role="center">
                        <div ku-block data-block-id="ku_quick_no_result_items">
                            <%=helper.render('noResultsFoundQuick',scope) %>
                        </div>
                    </section>
                    <section ku-container data-container-id="ku_quick_main_content_right" data-container-position="right"
                        data-container-role="right">
                    </section>
                </div>
            <% } %>
        <% } %>
    <% } else { %>
    <% } %>
`

/*
  klevuQuickAutoSuggestionsCustom, klevuQuickCategorySuggestionsCustom & klevuQuickPageSuggestionsCustom
  are the same as the default templates, but they must be defined here
  or they won’t show in quick search - it may be because of wrong configuration
*/
const klevuQuickAutoSuggestionsCustom = `
  <% if(data.suggestions.autosuggestion) { %>
        <% if(data.suggestions.autosuggestion.length> 0 ) { %>
            <% var queryParam = klevu.getSetting(klevu, "settings.url.queryParam"); %>
            <div class="klevuAutoSuggestionsWrap klevuAutosuggestions">
                <div class="klevuSuggestionHeading">
                    <span class="klevuHeadingText"> <%=helper.translate("Suggestions")%></span>
                </div>
                <ul>
                    <% helper.each(data.suggestions.autosuggestion,function(key,suggestion){ %>
                        <li tabindex="-1"><a target="_self" href="<%=helper.buildUrl(data.settings.landingUrl, queryParam , helper.stripHtml(suggestion.suggest))%>" data-content="<%=helper.stripHtml(suggestion.suggest) %>" class="klevu-track-click"> <%=suggestion.suggest %> </a></li>
                    <% }); %>
                </ul>
            </div>
        <% } %>
    <% } %>
`

const klevuQuickCategorySuggestionsCustom = `
  <% if(data.query.categoryCompressed) { %>
      <% if(data.query.categoryCompressed.result.length > 0 ){ %>
          <div class="klevuAutoSuggestionsWrap klevuCategorySuggestions" id="klevuCategoryArea">
              <div class="klevuSuggestionHeading">
                  <span class="klevuHeadingText"><%=helper.translate("Category")%></span>
              </div>
              <ul>
                  <% helper.each(data.query.categoryCompressed.result,function(key,category){ %>
                      <li tabindex="-1"><a target="_self" href="<%=category.url%>" class="klevu-track-click" data-url="<%=category.url%>" data-name="<%=category.name%>" ><%=category.name%></a></li>
                  <% }); %>
              </ul>
          </div>
      <% } %>
  <% } %>
`

const klevuQuickPageSuggestionsCustom = `
  <% if(data.query.cmsCompressed) { %>
    <% if(data.query.cmsCompressed.result.length > 0 ){ %>
          <div class="klevuAutoSuggestionsWrap klevuCmsSuggestions" id="klevuCmsContentArea">
              <div class="klevuSuggestionHeading"><span class="klevuHeadingText"><%=helper.translate("Pages")%></span></div>
              <ul>
                  <% helper.each(data.query.cmsCompressed.result,function(key,cms){ %>
                      <li tabindex="-1"><a target="_self" href="<%=cms.url%>" class="klevu-track-click" data-url="<%=cms.url%>" data-name="<%=cms.name%>"><%=cms.name%></a></li>
                  <% }); %>
              </ul>
          </div>
      <% } %>
  <% } %>
`

const klevuQuickNoResultsPopularProductsCustom = `
    <% var popularProductList = klevu.getObjectPath(data,"query.productListFallback.result");%>
    <% if(popularProductList) { %>
        <% if(popularProductList.length > 0 ) { %>
            <div class="klevuNoResultsProductsBlock">
                <div class="klevuPopularProductsHeading"><span class="klevuQuickHeadingText">MOST LOVED</span></div>
                <div class="klevuQuickSearchNoResultsPopular kuQuickResultsListContainer kuQuickSearchResultsContainer" data-section="noResultsFoundPopularProductList" id="noResultsFoundPopularProductList">
                    <ul>
                        <% helper.each(popularProductList,function(key, product){ %>
                            <%=helper.render('klevuQuickProductBlock',scope,data,product) %>
                        <% }); %>
                    </ul>
                </div>
            </div>
        <% } %>
    <% } %>
`

const klevuQuickTemplateTabResultsCustom = `
    <%
        var isCmsEnabled = klevu.search.modules.kmcInputs.base.getCmsEnabledValue();
        var hasAnyResultFound = false;
        helper.each(data.query,function(key,query) {
            if(query.tab == true) {
                if(helper.hasResults(data,query.id)) {
                    var results = data.query[query.id].meta.totalResultsFound;
                    if(results > 0){
                        hasAnyResultFound = true;
                    }
                }
            }
        });
    %>
    <div class="kuContainer">

        <% const totalResultsFound = Object.values(data.query).find(obj => obj && obj.id === "productList").meta.totalResultsFound %>
        <% if (totalResultsFound > 0 && !isCmsEnabled) { %>
            <div class="header-kuContainer-title">
                <span><%= helper.translate("Showing") %></span>
                <span><%= totalResultsFound %></span>
                <span><%= helper.translate("products") %></span>
            </div>
        <% } %>

        <div class="kuTabs" role="tablist" style="display:<%= isCmsEnabled && hasAnyResultFound ? 'block' : 'none'  %>">
            <% var selectedTab = false; %>
            <% helper.each(data.query,function(key,query){ %>
                <% if(query.tab == true) { %>
                    <% if(helper.hasResults(data,query.id)) { %>
                        <a target="_self" class="kuTab<% if(!selectedTab){ selectedTab = true; %> kuTabSelected<% } %>" data-section="<%=query.id%>" role="tab" tabindex="0" aria-selected="" area-label="Products tab">
                            <%=helper.translate(query.tabText,data.query[query.id].meta.totalResultsFound)%>
                        </a>
                    <% } else { %>
                        <a target="_self" class="kuTabDeactive" data-section="<%=query.id%>" role="tab" tabindex="0" aria-selected="" area-label="Products tab">
                            <%=helper.translate(query.tabText,0)%>
                        </a>
                    <% } %>
                <% } %>
            <% }); %>
        </div>
    </div>
`;

const klevuQuickTemplateFiltersCustom =
    `<% if(data.query[dataLocal].filters.length > 0 ) { %>
        <div class="kuFilters" role="navigation" data-position="left" aria-label="Product Filters" tabindex="0">
            <% helper.each(data.query[dataLocal].filters,function(key,filter){ %>
                <% if(filter.type == "OPTIONS"){ %>
                    <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                        <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                            <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                            <%=helper.translate(filter_label)%>
                        </div>
                        <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length <= 5 ) ? 'kuFilterShowAll': '' %> <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                            <ul>
                                <% helper.each(filter.options,function(key,filterOption){ %>
                                    <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                        <a
                                            target="_self"
                                            href="#"
                                            title="<%=helper.escapeHTML(filterOption.name)%>"
                                            class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>"
                                            data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                            data-name="<%=helper.escapeHTML(filterOption.name)%>"
                                        >
                                            <span class="kufacet-text"><%=filterOption.name%></span>
                                            <% if(filterOption.selected ==true) { %>
                                                <span class="kuFilterCancel">X</span>
                                            <% } else { %>
                                                <span class="kuFilterTotal"><%=filterOption.count%></span>
                                            <% } %>
                                            <span class="kuFilterIcon"></span>
                                        </a>
                                    </li>

                                <%  }); %>
                            </ul>
                            <% if(filter.options.length >= 5 ) { %>
                                <div class="kuShowOpt" tabindex="-1">
                                    <span class="kuShowOpt--collapsed">Show <%= filter.options.length - 5 %> more</span>
                                    <span class="kuShowOpt--expanded">Show less</span>
                                </div>
                            <% } %>
                        </div>
                    </div>
                <% } else if(filter.type == "SLIDER")  { %>
                	<div class="kuFilterBox klevuFilter" data-filter="<%=filter.key%>">
                        <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                        	<% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                            <%=helper.translate(filter_label)%>
                        </div>
                        <div class="kuFilterNames sliderFilterNames <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
  							<div class="kuPriceSlider klevuSliderFilter" data-query = "<%=dataLocal%>">
  								<div data-querykey = "<%=dataLocal%>" class="noUi-target noUi-ltr noUi-horizontal noUi-background kuSliderFilter kuPriceRangeSliderFilter<%=dataLocal%>"></div>
  							</div>
                        </div>
                    </div>
                <% } else if (filter.type == "RATING")  { %>
                    <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                        <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                            <%=helper.translate(filter.label)%>
                        </div>
                        <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length <= 5 ) ? 'kuFilterShowAll': '' %> <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                            <ul>
                                <% helper.each(filter.options,function(key,filterOption){ %>
                                    <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                        <a
                                            target="_self"
                                            href="#"
                                            title="<%=helper.escapeHTML(filterOption.name)%>"
                                            class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>"
                                            data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                            data-name="<%=helper.escapeHTML(filterOption.name)%>"
                                        >
                                            <span class="kufacet-text">
                                                <div class="klevuFacetStars">
                                                    <div class="klevuFacetRating" style="width:<%=(20*Number(filterOption.name))%>%;"></div>
                                                </div>
                                            </span>
                                            <% if(filterOption.selected ==true) { %>
                                                <span class="kuFilterCancel">X</span>
                                            <% } else { %>
                                                <span class="kuFilterTotal"><%=filterOption.count%></span>
                                            <% } %>
                                            <span class="kuFilterIcon"></span>
                                        </a>
                                    </li>

                                <%  }); %>
                            </ul>
                        </div>
                    </div>
                <% } else { %>
                    <!-- Other Facets -->
                <% } %>
            <% }); %>

            <!-- <div class="kuFiltersFooter">
            	<a target="_self" href="javascript:void(0)" class="kuBtn kuFacetsSlideOut kuMobileFilterCloseBtn" role="button" tabindex="0" area-label=""><%=helper.translate("Close")%></a>
  			</div> -->


        </div>
    <% } %>
`;

/* ====================================================== */
/* ====================================================== */
/* ======= KLEVU TEMPLATE JS CUSTOMIZATION CODE ========= */
/* ============ LANDING & CATNAV JAVASCRIPT ============= */
/* ====================== Blossom ======================= */
/* ====================================================== */
/* ====================================================== */

// Create the useroptions object if it does not already exist
if (!window.klevu_uc_userOptions) window.klevu_uc_userOptions = {};

// set the landingFilterPosition
window.klevu_uc_userOptions.landingFilterPosition = 'left';

klevu.beforeActivation("landing", function (data, scope) {

    scope.kScope.template.setTemplate(klevuLandingTemplateFiltersCustom, 'filters', true);
    scope.kScope.template.setTemplate(klevuLandingTemplateResultsCustom, 'results', true);

    scope.kScope.template.setTemplate(productTemplate, 'productBlock', true);
    scope.kScope.template.setTemplate(klevuNoResultsPopularProductsLandingCustom, 'noResultsLandingPopularProductsTemplate', true);

    scope.kScope.template.setTemplate(klevuLandingTemplateSearchBarCustom, 'klevuLandingTemplateSearchBar', true);

    scope.kScope.chains.events.keyUp.remove({ name: "scrollToTop" });

    (function (klevu) {
        klevu.extend(true, klevu.search.modules, {
            addParamsToURL: {
                base: {
                    addURLtoHistory: function (data, scope, queryId) {
                        // Global stuff
                        if (typeof window.history === "undefined" || typeof window.history.pushState === "undefined") {
                            console.error("This browser does not have the support of window.history or window.history.pushState");
                            return;
                        }

                        var searchPath = new URLSearchParams(window.location.search);
                        var currentSearchPath;
                        var previousSearchPath = searchPath.toString();

                        // this is in case we're running our code where we dont have context.activeQueryId
                        var activeQueryId = klevu.getObjectPath(data, "context.activeQueryId");
                        if (queryId && queryId.length) {
                            activeQueryId = queryId;
                        }

                        // Check if there any filter selected
                        let applyFilters = typeof data.localOverrides.query[activeQueryId].filters !== 'undefined' ? data.localOverrides.query[activeQueryId].filters.applyFilters : {};
                        let isThereFiltersSelected = false;
                        // Check if applyFilters is an object (but not an array), and not empty
                        if (typeof applyFilters === 'object' && !Array.isArray(applyFilters) && applyFilters !== null && Object.keys(applyFilters).length > 0) {
                            isThereFiltersSelected = true;
                        }

                        // PAGINATION TO URL
                        var hasPaginationEnabled = klevu.getSetting(klevu, "settings.theme.modules.pagination.searchResultsPage.enable");
                        var paginationQueryParam = "Page";
                        var currentPage = 0;

                        if (hasPaginationEnabled) {
                            var activeQueryMeta = klevu.getObjectPath(data, "template.query." + activeQueryId + ".meta");
                            if (activeQueryMeta) {
                                var productListLimit = activeQueryMeta.noOfResults;
                                currentPage = Math.ceil(activeQueryMeta.offset / productListLimit) + 1;
                            }

                            if (currentPage === 0 || currentPage === 1) {
                                searchPath.delete(paginationQueryParam);
                            } else {
                                searchPath.set(paginationQueryParam, currentPage);
                            }

                            currentSearchPath = searchPath.toString();
                        };

                        // FILTERS TO URL
                        var activeQueryFilters = klevu.getObjectPath(data, "template.query." + activeQueryId + ".filters");
                        var filterValuesQueryParam = "";

                        if (activeQueryFilters) {
                            klevu.each(activeQueryFilters, function (key, filter) {
                                var selectedFilterKeyString = "";
                                var filterOptions = filter.options;
                                var selectedValues = "";

                                if (filterOptions && filterOptions.length) {
                                    klevu.each(filterOptions, function (key, option) {
                                        if (option.selected === true) {
                                            if (selectedValues.length) {
                                                selectedValues += ",";
                                            }
                                            selectedValues += option.value;
                                        }
                                    });
                                } else if (filter.type === "SLIDER") {
                                    var startValue = filter.start;
                                    var endValue = filter.end;
                                    var minValue = filter.min;
                                    var maxValue = filter.max;
                                    if (typeof startValue !== "undefined" && startValue !== null && typeof endValue !== "undefined" && endValue !== null) {
                                        if (Number(startValue) === Number(minValue) && Number(endValue) === Number(maxValue)) {
                                            // just skipping
                                        } else {
                                            selectedValues = startValue + "-" + endValue;
                                        }
                                    }
                                }

                                if (selectedValues.length) {
                                    // selectedFilterKeyString += filter.key + ":" + selectedValues;
                                    selectedFilterKeyString += encodeURIComponent(filter.key) + ":" + encodeURIComponent(selectedValues);
                                }

                                if (selectedFilterKeyString.length) {
                                    if (filterValuesQueryParam.length) {
                                        filterValuesQueryParam += ";";
                                    }
                                    filterValuesQueryParam += selectedFilterKeyString;
                                }
                            });
                        }

                        if (filterValuesQueryParam.length > 0 && isThereFiltersSelected) {
                            searchPath.set("Filters", filterValuesQueryParam);
                        } else {
                            searchPath.delete("Filters");
                        }

                        currentSearchPath = searchPath.toString();

                        // ==============================
                        // Final URL change
                        if (previousSearchPath !== currentSearchPath) {
                            var historyState = { page: currentPage, filters: currentSearchPath };
                            window.history.pushState(historyState, null, currentSearchPath ? '?' + currentSearchPath : window.location.pathname);
                        }
                    },

                    restoreSearchParamsOnPageLoad: function (data, scope) {
                        var hasAlreadyTriggered = klevu.getObjectPath(scope.kScope, "element.kScope.getAndUpdateFiltersTriggered");
                        if (hasAlreadyTriggered) return;

                        var activeQueryId = klevu.getObjectPath(data, "context.activeQueryId") || "productList";

                        var filtersFromURL = klevu.dom.helpers.getQueryStringValue("Filters");
                        var paginationFromURL = klevu.dom.helpers.getQueryStringValue("Page");

                        var matchedQueryParamId = "";
                        var matchedQueryParamValue = "";
                        var recordQueries = klevu.getObjectPath(data, "request.current.recordQueries");

                        if (recordQueries && recordQueries.length) {
                            klevu.each(recordQueries, function (key, recordQuery) {
                                if (recordQuery.id) {
                                    if ((paginationFromURL && paginationFromURL.length) || (filtersFromURL && filtersFromURL.length)) {
                                        matchedQueryParamId = recordQuery.id;
                                        matchedQueryParamValue = paginationFromURL || filtersFromURL;
                                    }
                                }
                            });
                        }

                        klevu.setObjectPath(scope.kScope, "element.kScope.getAndUpdateFiltersTriggered", true);

                        matchedQueryParamId = activeQueryId || "productList";

                        if (matchedQueryParamId.length && matchedQueryParamValue.length) {
                            activeQueryId = matchedQueryParamId;
                            var storage = klevu.getSetting(scope.kScope.settings, "settings.storage");
                            if (storage.tabs) {
                                storage.tabs.setStorage("local");
                                storage.tabs.mergeFromGlobal();
                                storage.tabs.addElement("active", activeQueryId);
                                storage.tabs.mergeToGlobal();
                            }
                        }

                        if (paginationFromURL && paginationFromURL > 1) {
                            if (recordQueries && recordQueries.length) {
                                klevu.each(recordQueries, function (key, recordQuery) {
                                    if (recordQuery.id === activeQueryId) {
                                        var limit = klevu.getObjectPath(recordQuery, "settings.limit");
                                        limit = Number(limit);
                                        if (limit > 0) {
                                            var expectedOffset = (paginationFromURL - 1) * limit;
                                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".settings.offset", expectedOffset);
                                        }
                                    }
                                });
                            }
                        }

                        // FILTERS
                        if (filtersFromURL && filtersFromURL.length) {
                            var facets = filtersFromURL.split(";");
                            if (facets) {
                                klevu.each(facets, function (key, facet) {
                                    var splitFacet = facet.split(":");
                                    if (splitFacet.length) {
                                        var facetKey = decodeURIComponent(splitFacet[0]);
                                        var facetValues = decodeURIComponent(splitFacet[1]).split(",");
                                        var applyFilters = klevu.getObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters");

                                        if (applyFilters && applyFilters.length) { // if there're some filters
                                            var isExistingKey = false;
                                            klevu.each(applyFilters, function (key, applyFilter) {
                                                if (applyFilter.key === facetKey) {
                                                    isExistingKey = true;
                                                    klevu.each(facetValues, function (key, facetValue) {
                                                        var isFilterOptionMatched = false;
                                                        klevu.each(applyFilter.values, function (key, value) {
                                                            if (facetValue === value) {
                                                                isFilterOptionMatched = true;
                                                            }
                                                        });
                                                        if (!isFilterOptionMatched) {
                                                            applyFilter.values.push(facetValue);
                                                        }
                                                    });
                                                }
                                            });
                                            if (!isExistingKey) {
                                                applyFilters.push({ key: facetKey, values: facetValues });
                                            }
                                        } else {
                                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", [{ key: facetKey, values: facetValues }]);
                                        }

                                    }
                                });
                            }
                        }
                    },

                    updatePayloadOnPopState: function (data, scope, activeQueryId) {
                        // SET PAGINATION PAYLOAD
                        var paginationFromURL = klevu.dom.helpers.getQueryStringValue("Page");
                        paginationFromURL = Number(paginationFromURL);
                        var limit = window.klevuCurrentScope.element.kObject.getScope().data.request.original.queryRequest[0].settings.limit;
                        limit = Number(limit);
                        if (limit > 0) {
                            var expectedOffset = ((paginationFromURL - 1) * limit) > 0 ? ((paginationFromURL - 1) * limit) : 0;
                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".settings.offset", expectedOffset);
                            // klevu.search.modules.addParamsToURL.base.backBtnCounter.backBtn = 0;
                        }

                        // SET FILTER PAYLOAD
                        var filtersFromURL = klevu.dom.helpers.getQueryStringValue("Filters");
                        if (filtersFromURL && filtersFromURL.length) {
                            var facets = filtersFromURL.split(";");
                            // loop through all facets to get its values
                            let facetKey = '';
                            let facetValues = [];
                            let facetsArray = [];

                            klevu.each(facets, function (key, facet) {
                                var splitFacet = facet.split(":");
                                if (splitFacet.length) {
                                    facetKey = decodeURIComponent(splitFacet[0]);
                                    facetValues = decodeURIComponent(splitFacet[1]).split(",");
                                    facetsArray.push({ key: facetKey, values: facetValues });
                                }
                            });
                            // set the payload with correct filters:
                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", facetsArray);
                        } else { // reset filters if Back button pressed, and there's no filters
                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", []);
                        }
                    }
                },
                build: true
            },
            filterOpener: function (data, scope) {
                var filterOpener = document.querySelector('.ku-facet-opener');
                var filterClose = document.querySelector('.ku-facet-close');
                var filterApply = document.querySelector('.kuFiltersMobButton_apply');
                var landingElement = document.querySelector('.klevuLanding');
                if (filterOpener && landingElement) {
                    klevu.event.attach(filterOpener, "click", function (event) {
                        document.querySelector('.klevuLanding ').classList.toggle('ku-facet-open');
                    });
                }
                if (filterClose && landingElement) {
                    klevu.event.attach(filterClose, "click", function (event) {
                        document.querySelector('.klevuLanding ').classList.toggle('ku-facet-open');
                    });
                }
                if (filterApply && landingElement) {
                    klevu.event.attach(filterApply, "click", function (event) {
                        document.querySelector('.klevuLanding ').classList.toggle('ku-facet-open');
                    });
                }
            },
            insertToTopButton: function (data, scope) {
                let topButton = document.getElementById('ku-back-to-top');
                if (!topButton) {
                    topButton = document.createElement('button');
                    topButton.id = 'ku-back-to-top';
                    topButton.title = 'Back to top';
                    topButton.className = 'ku-hide';
                    topButton.textContent = '↑';
                    document.body.appendChild(topButton);
                }

            },
            addBodyClassOnScroll: function () {
                // Helper function to get the top position of an element
                function getElementYPosition () {
                    var element = document.querySelector('.kuResultsListing');
                    if (element) {
                        var boundingClientRect = element.getBoundingClientRect();
                        var absoluteElementTop = boundingClientRect.top + window.pageYOffset;
                        return absoluteElementTop;
                    }
                    return null; // Return null if the element doesn't exist
                };
                window.addEventListener('scroll', function (e) {
                    const positionY = window.scrollY;
                    const productListPositionY = getElementYPosition();
                    const triggerPositionY = productListPositionY !== null ? productListPositionY : 100;
                    const body = document.body;
                    const shouldAddClass = positionY >= triggerPositionY;
                    body.classList.toggle('klevu-sticky', shouldAddClass);
                });
            },
            smoothScrollToProductListingTop: function () {
                let customOffset = 60;
                const selectorsToTriggerScrollToTop = {
                    pagination: '.kuPagination a',
                    scrollToTopButton: '#ku-back-to-top'
                  // filterOptions: '.klevuFilterOption',
                  // Add more selectors here as needed
                }
                function _smoothScrollToKlevuTop() {
                  setTimeout(function () {
                      var target = document.getElementsByClassName('klevuMeta')[0];

                      if (target) {
                          var topPosition = target.getBoundingClientRect().top + window.pageYOffset;

                          window.scrollTo({
                              top: topPosition - customOffset,
                              behavior: 'smooth'
                          });
                      }
                  }, 100);
                }
                Object.values(selectorsToTriggerScrollToTop).forEach(selector => {
                  document.querySelectorAll(selector).forEach(el => el.addEventListener('click', _smoothScrollToKlevuTop));
                });
            },
            keepFacetsWithSelectedOptionsOpened: function (data, scope) {
                const selectors = {
                    kuFilterBox: '.kuFilterBox',
                    kuSelected: '.kuSelected',
                    kuFilterNames: '.kuFilterNames',
                    kuFilterNamesCollapse: '.kuFilterNames.kuFilterCollapse',
                    kuFilterHead: '.kuFilterHead',
                    kuFilterHeadExpand: '.kuFilterHead.kuExpand',
                    kuExpand: '.kuExpand',
                    kuCollapse: '.kuCollapse',
                    nouiElement: '.noUi-origin',
                    priceFacetBlock: '[data-filter="klevu_price"]',
                    kuFilterShowAll: '.kuFilterShowAll',
                    kuFilterCollapse: '.kuFilterCollapse',
                };

                /** Collapse Filters by default */
                (function collapseAllFilters() {
                    // Replace .kuFilterHead.kuCollapse with .kuFilterHead.kuExpand
                    const kuFilterHeadElements = document.querySelectorAll(selectors.kuFilterHead);
                    kuFilterHeadElements.forEach(element => {
                        element.classList.add(selectors.kuExpand.substring(1));
                        element.classList.remove(selectors.kuCollapse.substring(1));
                    });

                    // Replace .kuFilterNames.kuCollapse with .kuFilterNames.kuExpand
                    const kuFilterNamesElements = document.querySelectorAll(selectors.kuFilterNames);
                    kuFilterNamesElements.forEach(element => {
                        element.classList.add(selectors.kuFilterCollapse.substring(1));
                        element.classList.remove(selectors.kuFilterShowAll.substring(1));
                    });
                }());


                // Regular checkbox-facets
                // Check if the required elements exist
                const kuSelectedElements = document.querySelectorAll(selectors.kuFilterBox + ' ' + selectors.kuSelected);
                if (kuSelectedElements.length > 0) {
                    kuSelectedElements.forEach(selectedElement => {
                        // Find the parent element with the class kuFilterBox
                        const filterBoxParent = findParentWithClass(selectedElement, selectors.kuFilterBox);

                        // Look for the child with the class kuFilterHead.kuExpand
                        const filterHeadChild = filterBoxParent.querySelector(selectors.kuFilterHeadExpand);

                        // Rotate icon in the title
                        if (filterHeadChild) {
                            filterHeadChild.classList.remove('kuExpand');
                            filterHeadChild.classList.add('kuCollapse');
                        }

                        // Find the parent element with the class kuFilterNames.kuFilterCollapse
                        const filterNamesParent = findParentWithClass(selectedElement, selectors.kuFilterNamesCollapse);

                        // Show options
                        if (filterNamesParent) {
                            filterNamesParent.classList.remove('kuFilterCollapse');
                            filterNamesParent.classList.add(selectors.kuFilterShowAll.substring(1));
                        }
                    });
                }

                    // Price slider facet
                    var isThereAnyAppliedFacets = klevu.getObjectPath(
                        scope.kScope.data,
                        "localOverrides.query." +
                        scope.kScope.data.context.activeQueryId +
                        ".filters.applyFilters.filters"
                    );
                    const isPriceFacetApplied = Boolean(isThereAnyAppliedFacets?.filter(val => val.key === "klevu_price").length);
                    if (isPriceFacetApplied) {
                    // Find the parent element with the class kuFilterNames.kuFilterCollapse
                    const nouiElement = document.querySelector(`${selectors.priceFacetBlock} ${selectors.nouiElement}`);

                    if (nouiElement) {
                        const filterNamesParent = findParentWithClass(nouiElement, selectors.kuFilterNamesCollapse);

                        // Show options
                        if (filterNamesParent) {
                            filterNamesParent.classList.remove('kuFilterCollapse');
                            filterNamesParent.classList.add(selectors.kuFilterShowAll.substring(1));
                        }

                        // Find the parent element with the class kuFilterBox
                        const filterBoxParent = findParentWithClass(nouiElement, selectors.kuFilterBox);

                        // Look for the child with the class kuFilterHead.kuExpand
                        const filterHeadChild = filterBoxParent.querySelector(selectors.kuFilterHeadExpand);

                        // Rotate icon in the title
                        if (filterHeadChild) {
                            filterHeadChild.classList.remove('kuExpand');
                            filterHeadChild.classList.add('kuCollapse');
                        }
                    }
                }

                // Function-helper to find the parent element with a specified class
                function findParentWithClass(element, className) {
                    let parent = element.parentElement;
                    while (parent) {
                        if (parent.matches(className)) {
                            return parent;
                        }
                        parent = parent.parentElement;
                    }
                    return null; // No matching parent found
                }
            }
        });
    })(klevu);

})

// Apply the facets supplied in the current URL string
klevu.modifyRequest("landing", function (data, scope) {

    if (localStorage.getItem('klv_sort_productList') !== null) {
        localStorage.removeItem('klv_sort_productList');
    }

    klevu.each(data.request.current.recordQueries, function (key, query) {
      if (query.filters && query.filters.filtersToReturn && query.filters.filtersToReturn.options) {
        query.filters.filtersToReturn.options.limit = 21;
      }
    });
    // Restore Search Params On Page Load
    klevu.search.modules.addParamsToURL.base.restoreSearchParamsOnPageLoad(data, scope);

    // set the global scope
    window.klevuCurrentScope = scope.kScope;
});

klevu.afterTemplateRender("landing", function (data, scope) {
    klevu.search.modules.addParamsToURL.base.addURLtoHistory(data, scope);
    klevu.search.modules.insertToTopButton(data, scope);
    klevu.search.modules.filterOpener(data, scope);
    klevu.search.modules.addBodyClassOnScroll();
    klevu.search.modules.keepFacetsWithSelectedOptionsOpened(data, scope);
    klevu.search.modules.smoothScrollToProductListingTop(data, scope);

    const filterOpeners = document.querySelectorAll(".ku-filters-opener");
    const leftContainer = document.querySelector('.kuSearchResultsPageContainer [data-container-role="left"]');

    filterOpeners.forEach((filterOpener) => {
      filterOpener.addEventListener("click", () => {
        if (!leftContainer) return;
        leftContainer.classList.toggle("kuFiltersHidden");
        filterOpener.classList.toggle("active");
      })
    })
});

klevu.afterTemplateRender('landing', async function (data, scope) {
    try {
        var productIds = data.template.query.productList?.result
            || data.template.query.noResultsFoundPopularProductList?.result
            || [];
        await renderKlevuProductCards(productIds, '.kuLandingResultsListContainer');
    } catch (err) {
        console.log('Klevu landing render error:', err);
    }
});

window.onpopstate = function (event) {
    try {
        // passing activeQueryId because it's lost once we reset the data below
        var activeQueryId = klevu.getObjectPath(window.klevuCurrentScope.element.kObject.getScope().data, "context.activeQueryId");
        // code to get ready to reset all the data
        var data = window.klevuCurrentScope.element.kObject.getScope().data;
        var scope = window.klevuCurrentScope.element;
        scope.kScope.data = scope.kObject.resetData(scope.kElem);
        scope.kScope.data.context.keyCode = 0;
        scope.kScope.data.context.eventObject = event;
        scope.kScope.data.context.event = "keyUp";
        scope.kScope.data.context.preventDefault = false;

        // Get payload for Filters & Pagination
        klevu.search.modules.addParamsToURL.base.updatePayloadOnPopState(data, scope, activeQueryId);

        // Fire request, re-render results
        klevu.event.fireChain(scope.kScope, "chains.events.keyUp", scope, scope.kScope.data, event);
    } catch (error) {
        console.log(error)
    }
};
/* ============ LANDING & CATNAV TEMPLATES ============= */

var klevuLandingTemplateSearchBarCustom = `
    <% var queryParam = klevu.getGlobalSetting("url.queryParam"); %>
    <% var baseUrl = window.theme.base_url_with_market; %>
    <div class="kuSearchResultsSearchBarContainer kuHideExtraSearch">
         <form action="<%= baseUrl %>/search" method="get" class="header-bar__search-form">
            <input type="text" name="<%= queryParam %>" id="search" class="kuSearchInput header-bar__search-input" placeholder="<%=helper.translate("Search text")%>" />
            <button type="submit" name="submitsearch" class="button theme-btn">
                <span class="aicon icon-mm-search"></span>
            </button>
        </form>
    </div>
`;

var klevuLandingTemplateFiltersCustom = `
    <% if(data.query[dataLocal].filters.length > 0 ) { %>
        <div class="kuFilters" role="navigation" data-position="left" aria-label="Product Filters" tabindex="0">
        <div class="kuFiltersMobHeader">
          Filters
        </div>
        <div class="kuFiltersMobButtons">
            <button class="kuFiltersMobButton kuFiltersMobButton_apply" tabindex="0"><%= helper.translate("Apply")%></button>
            <button class="kuFiltersMobButton kuFiltersMobButton_reset kuFilterTagClearAll" tabindex="0">Reset</button>
        </div>

        <h3 class="kuFiltersTitleHeading"><%=helper.translate("Filter by")%></h3>

            <% helper.each(data.query[dataLocal].filters,function(key,filter){ %>
                <% if(filter.type == "OPTIONS"){ %>
                    <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                        <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                            <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                            <%=helper.translate(filter_label)%>
                            <span class="open-more-cross"></span>
                        </div>
                        <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length <= 5 ) ? 'kuFilterShowAll': '' %> <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                            <ul>
                                <% helper.each(filter.options,function(key,filterOption){ %>
                                    <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                        <a
                                            target="_self"
                                            href="#"
                                            title="<%=helper.escapeHTML(filterOption.name)%>"
                                            class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>"
                                            data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                            data-name="<%=helper.escapeHTML(filterOption.name)%>"
                                        >
                                            <span class="kufacet-text"><%=filterOption.name%></span>
                                            <% if(filterOption.selected ==true) { %>
                                                <span class="kuFilterCancel">X</span>
                                            <% } else { %>
                                                <span class="kuFilterTotal"><%=filterOption.count%></span>
                                            <% } %>
                                            <span class="kuFilterIcon"></span>
                                        </a>
                                    </li>

                                <%  }); %>
                            </ul>
                            <% if(filter.options.length >= 5 ) { %>
                                <div class="kuShowOpt" tabindex="-1">
                                    <span class="kuShowOpt--collapsed">Show <%= filter.options.length - 5 %> more</span>
                                    <span class="kuShowOpt--expanded">Show less</span>
                                </div>
                            <% } %>
                        </div>
                    </div>
                <% } else if(filter.type == "SLIDER")  { %>
                	<div class="kuFilterBox klevuFilter" data-filter="<%=filter.key%>">
                        <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                        	<% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                            <%=helper.translate(filter_label)%>
                            <span class="open-more-cross"></span>
                        </div>
                        <div class="kuFilterNames sliderFilterNames <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
  							<div class="kuPriceSlider klevuSliderFilter" data-query = "<%=dataLocal%>">
  								<div data-querykey = "<%=dataLocal%>" class="noUi-target noUi-ltr noUi-horizontal noUi-background kuSliderFilter kuPriceRangeSliderFilter<%=dataLocal%>"></div>
  							</div>
                        </div>
                    </div>
                <% } else if (filter.type == "RATING")  { %>
                    <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                        <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                            <%=helper.translate(filter.label)%>
                            <span class="open-more-cross"></span>
                        </div>
                        <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length <= 5 ) ? 'kuFilterShowAll': '' %> <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                            <ul>
                                <% helper.each(filter.options,function(key,filterOption){ %>
                                    <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                        <a
                                            target="_self"
                                            href="#"
                                            title="<%=helper.escapeHTML(filterOption.name)%>"
                                            class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>"
                                            data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                            data-name="<%=helper.escapeHTML(filterOption.name)%>"
                                        >
                                            <span class="kufacet-text">
                                                <div class="klevuFacetStars">
                                                    <div class="klevuFacetRating" style="width:<%=(20*Number(filterOption.name))%>%;"></div>
                                                </div>
                                            </span>
                                            <% if(filterOption.selected ==true) { %>
                                                <span class="kuFilterCancel">X</span>
                                            <% } else { %>
                                                <span class="kuFilterTotal"><%=filterOption.count%></span>
                                            <% } %>
                                            <span class="kuFilterIcon"></span>
                                        </a>
                                    </li>

                                <%  }); %>
                            </ul>
                        </div>
                    </div>
                <% } else { %>
                    <!-- Other Facets -->
                <% } %>
            <% }); %>

            <!-- <div class="kuFiltersFooter">
            	<a target="_self" href="javascript:void(0)" class="kuBtn kuFacetsSlideOut kuMobileFilterCloseBtn" role="button" tabindex="0" area-label=""><%=helper.translate("Close")%></a>
  			</div> -->


        </div>
        <button class="ku-facet-close"><span class="mobile-filter__close"><svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" class="icon icon__close uc__hideFacets" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"></path></svg></span></button>
    <% } %>
`;

var productTemplate = `
    <li ku-product-block class="klevuProduct klevuProductClick kuTrackRecentView grid__item" data-id="<%=dataLocal.id%>">
        <div class="kuProdWrapHolder"></div>
    </li>
`;

var quickProductTemplate = `
    <li ku-product-block class="klevuProduct trackProductClick kuTrackRecentView grid__item" data-id="<%=dataLocal.id%>">
        <div class="kuProdWrapHolder"></div>
    </li>
`;

var klevuLandingTemplateResultsCustom = `
    <div class="kuResultsListing">
        <div class="productList klevuMeta" data-section="productList">
            <div class="kuResultContent">
                <div class="kuResultWrap <%=(data.query.productList.filters.length == 0 )?'kuBlockFullwidth':''%>">

                    <div class="ku-text-found">
                        <% if (data?.settings?.categoryPath === undefined) { %>
                                <h2><%=data.query.productList.meta.totalResultsFound %> <%= helper.translate("PRODUCTS FOUND FOR") %> "<%=data.query.productList.meta.searchedTerm %>"</h2>
                        <% } else { %>
                                <h2><%= data.settings.categoryPath %> </h2>
                        <% } %>
                    </div>

                    <div ku-container class="ku-filter-bar">
                        <header ku-block data-block-id="ku_landing_result_header">
                            <div>
                              <div class="ku-filters-opener active">
                                  <span class="ku-filters-opener--closed">Filters</span>
                                  <span class="ku-filters-opener--opened">Hide Filters (<%=data.query.productList.filters.length %>)</span>
                                  <span class="open-more-cross">
                              </div>
                            </div>
                            <div class="ku-bar-mobile-wrapper">
                              <%
                                  var lastPageResults = (Number(data.query.productList.meta.noOfResults) + Number(data.query.productList.meta.offset)) > data.query.productList.meta.totalResultsFound ? data.query.productList.meta.totalResultsFound : (Number(data.query.productList.meta.noOfResults) + Number(data.query.productList.meta.offset));
                                  var results = ((Number(data.query.productList.meta.offset) !== 0) ? Number(data.query.productList.meta.offset) : '') + ' - ' + lastPageResults;
                                  if(results > data.query.productList.meta.totalResultsFound){
                                      results = data.query.productList.meta.totalResultsFound;
                                  }
                              %>
                              <div class="ku-numberOfResults">showing <%= results %> of <%=data.query.productList.meta.totalResultsFound %></div>
                              <button class="ku-facet-opener"><span>Filters (<%=data.query.productList.filters.length %>)<span class="open-more-cross"></span></span></button>
                              <%=helper.render('klevuLandingTemplateResultsHeadingTitle',scope,data,"productList") %>
                              <%=helper.render('filtersTop',scope,data,"productList") %>
                              <% if(helper.hasResults(data,"productList")) { %>
                                  <%=helper.render('limit',scope,data,"productList") %>
                                  <%=helper.render('kuTemplateLandingResultsViewSwitch',scope,data,"productList") %>
                                  <%=helper.render('pagination',scope,data,"productList") %>
                                  <%=helper.render('sortBy',scope,data,"productList") %>
                              <% } %>
                              <div class="kuClearBoth"></div>
                            </div>
                        </header>
                    </div>

                    <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                        <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                            <div ku-block data-block-id="ku_landing_left_facets">
                                <%=helper.render('filters',scope,data,"productList") %>
                            </div>
                            <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_left_banner"></div>
                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center" class="kuMainContentWrapper">
                          <%= helper.render('kuFilterTagsTemplate',scope,data,"productList") %>
                          <div ku-block data-block-id="ku_landing_result_items">
                                <div class="kuResults kuLandingResultsListContainer">
                                    <% if(helper.hasResults(data,"productList")) { %>
                                        <ul>
                                            <% helper.each(data.query.productList.result,function(key,item){ %>
                                                <% if(item.typeOfRecord == "KLEVU_PRODUCT") { %>
                                                    <%=helper.render('productBlock',scope,data,item) %>
                                                <% } %>
                                            <% }); %>
                                        </ul>
                                    <% } else { %>
                                        <div class="kuNoRecordsFoundLabelTextContainer">
                                            <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                        </div>
                                    <% } %>
                                    <div class="kuClearBoth"></div>
                                </div>
                            </div>
                            <% if(helper.hasResults(data,"productList")) { %>
                                <%=helper.render('pagination',scope,data,"productList") %>
                            <% } %>


                            <div ku-block data-block-id="ku_landing_other_items">
                                <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>
                            </div>
                            <footer ku-block data-block-id="ku_landing_result_footer"></footer>
                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                            <div ku-block data-block-id="ku_landing_right_facets"></div>
                            <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_right_banner"></div>
                        </section>
                    </div>

                </div>
            </div>
        </div>

        <% if(data.query.contentList) { %>
            <div class="contentList klevuMeta" data-section="contentList" data-result-view="list">
                <div class="kuResultContent">
                    <div class="kuResultWrap <%=(data.query.contentList.filters.length == 0 )?'kuBlockFullwidth':''%>">

                        <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                            <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                                <div ku-block data-block-id="ku_landing_left_facets">

                                    <%=helper.render('filters',scope,data,"contentList") %>

                                </div>
                                <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                                <div ku-block data-block-id="ku_landing_left_banner"></div>
                            </section>
                            <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">

                                <header ku-block data-block-id="ku_landing_result_header">
                                    <%=helper.render('filtersTop',scope,data,"contentList") %>
                                    <%= helper.render('kuFilterTagsTemplate',scope,data,"contentList") %>
                                    <% if(helper.hasResults(data,"contentList")) { %>
                                        <%=helper.render('limit',scope,data,"contentList") %>
                                        <%=helper.render('pagination',scope,data,"contentList") %>
                                    <% } %>
                                    <div class="kuClearBoth"></div>
                                </header>

                                <div ku-block data-block-id="ku_landing_result_items">
                                    <div class="kuClearBoth"></div>
                                    <div class="kuResults">
                                        <% if(helper.hasResults(data,"contentList")) { %>
                                            <ul>
                                                <% helper.each(data.query.contentList.result,function(key,item){ %>
                                                    <% if(item.typeOfRecord == "KLEVU_CMS") { %>
                                                        <%=helper.render('contentBlock',scope,data,item) %>
                                                    <% }%>
                                                <% }); %>
                                            </ul>
                                        <% } else { %>
                                            <div class="kuNoRecordsFoundLabelTextContainer">
                                                <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                            </div>
                                        <% } %>
                                        <div class="kuClearBoth"></div>
                                    </div>
                                </div>
                                <div ku-block data-block-id="ku_landing_other_items">
                                    <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>
                                </div>
                                <footer ku-block data-block-id="ku_landing_result_footer"></footer>
                            </section>
                            <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                                <div ku-block data-block-id="ku_landing_right_facets"></div>
                                <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                                <div ku-block data-block-id="ku_landing_right_banner"></div>
                            </section>
                        </div>

                    </div>
                </div>
            </div>
        <% } %>

    </div>
`;

const klevuNoResultsPopularProductsLandingCustom = `
<div class="kuNoResultsProductRecommendationSlider kuNoResultsPopularProducts" data-section="noResultsFoundPopularProductList">
        <% var popularProductList = klevu.getObjectPath(data,"query.noResultsFoundPopularProductList.result");%>
        <% if(popularProductList && popularProductList.length) { %>
            <div class="klevuNoResultsRecs" title="<%= helper.translate(data.landingNoResultsPopularHeading) %>">
                <h3><%= helper.translate(data.landingNoResultsPopularHeading) %> </h3>
            </div>
            <div class="klevuNoResultsRecsWrap">
                    <div class="klevuNoResultsRecsResults">
                        <div class="klevuNoResultsRecsResultsInner kuLandingResultsListContainer">
                            <ul>
                              <% helper.each(popularProductList,function(key,product){ %>
                                  <%=helper.render('productBlock',scope,data,product) %>
                              <% }); %>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        <% } %>
    </div>
`
